const initialState = {
    deck: { 
        main: [],
        groupedByType: {},    // 🆕 Nueva propiedad para agrupamiento por tipo
        goldCurve: {}        // 🆕 Nueva propiedad para curva de oro
    },
    lister: [],
    isLoading: false,
    hasMoreItemsToLoad: false,
    nextPageToLoad: null,
    searchActive: false,
};

// Función helper para agrupar por tipo (la movemos fuera del reducer para reutilización)
const groupByType = (deck) => {
    return deck.reduce((groups, card) => {
        const type = card.Tipo || "Desconocido";
        if (!groups[type]) groups[type] = [];
        groups[type].push(card);
        return groups;
    }, {});
};

// Función helper para agrupar por costo (gold curve)
const groupByGold = (deck) => {
    return deck.reduce((groups, card) => {
        let cost = card.Coste;
        if (cost === undefined || cost === null || isNaN(cost)) return groups;

        // Agrupar todos los costes >= 6 como "6"
        cost = cost >= 6 ? 6 : cost;

        if (!groups[cost]) groups[cost] = 0;
        groups[cost] += card.quantity || 1;
        return groups;
    }, {});
};



const reducer = (state = initialState, action) => {
    let { payload, type } = action;

    switch (type) {
        case 'UPDATE_LISTER':
            return {
                ...state,
                lister: [...payload]
            };

        case "IMPORT_DECK":
            console.log("Payload recibido en IMPORT_DECK:", payload);

            if (!Array.isArray(payload)) {
                console.error("Error: payload no es un array", payload);
                return state; // No modificar el estado si hay un error
            }

            // 🟢 Fusionar cartas repetidas en el mazo
            const mergedDeck = payload.reduce((acc, card) => {
                const existingCard = acc.find(c => c.Id === card.Id);
                if (existingCard) {
                    existingCard.quantity += card.quantity || 1; // Evitar NaN si no tiene quantity
                } else {
                    acc.push({ ...card, quantity: card.quantity || 1 }); // Asegurar que tenga cantidad mínima 1
                }
                return acc;
            }, []);

            return {
                ...state,
                deck: {
                    main: mergedDeck.map(card => ({
                        ...card,
                        mini_img: card.mini_img || "URL_IMAGEN_DEFECTO"
                    }))
                }
            };

            // ... otros cases (UPDATE_LISTER, etc.)
    

        
        case 'UPDATE_LISTER_ITEMS':
            return {
                ...state,
                lister: [...state.lister, ...payload]
            };
        case 'UPDATE_DECK_GROUPS': {
            // Debug: verifica el estado actual
            console.log("Mazo actual para agrupación:", state.deck.main);
            
            const newGroupedByType = groupByType(state.deck.main) || {};
            const newGoldCurve = groupByGold(state.deck.main) || {};
            
            console.log("Nuevo groupedByType:", newGroupedByType);
            console.log("Nuevo goldCurve:", newGoldCurve);
            
            return {
                ...state,
                deck: {
                    ...state.deck,
                    groupedByType: newGroupedByType,
                    goldCurve: newGoldCurve
                }
            };
        }
    
        case 'ADD_CARD_TO_DECK': {
            const mainDeck = state.deck.main || []; // Asegurar que sea un array
            const cardIndex = mainDeck.findIndex(card => card.Id === payload.Id);

            if (cardIndex !== -1) {
                // 🟢 Si la carta ya existe, solo aumenta la cantidad
                return {
                    ...state,
                    deck: {
                        main: mainDeck.map((card, index) =>
                            index === cardIndex
                                ? { ...card, quantity: card.quantity + 1 }
                                : card
                        )
                    }
                };
            } else {
                // 🟢 Si la carta no existe, agrégala con cantidad 1
                return {
                    ...state,
                    deck: {
                        main: [...mainDeck, { ...payload, quantity: 1 }]
                    }
                };
            }
        }

        case 'REMOVE_CARD': {
            const mainDeck = state.deck.main || []; // Asegurar que sea un array

            return {
                ...state,
                deck: {
                    main: mainDeck
                        .map(card => 
                            card.Id === payload.Id 
                                ? { ...card, quantity: card.quantity - 1 } 
                                : card
                        )
                        .filter(card => card.quantity > 0) // Eliminar cartas con cantidad 0
                }
            };
        }

        case 'ERASE_DECK':
            return {
                ...state,
                deck: { main: [] } // ✅ Asegurar que es un array vacío
            };

        case 'SET_LOADING_STATE':
            return {
                ...state, isLoading: payload
            };

        case 'SET_HAS_MORE_ITEMS_TO_LOAD':
            return {
                ...state, hasMoreItemsToLoad: payload
            };

        case 'SET_NEXT_PAGE_TO_LOAD':
            return {
                ...state,
                nextPageToLoad: payload
            };
        case 'SET_SEARCH_ACTIVE':
            return { ...state, searchActive: payload };
        case "SET_SELECTED_CARD":
            return { ...state, selectedCardId: action.payload };
            
                

        default:
            return state;
    }
};

export default reducer;
